export const resizeImage = (filename: string, resizeValue?: string) => {
  if (filename.split(".").pop() === "gif") return filename;
  const dotIndex = filename.lastIndexOf(".");
  return `${filename.substring(0, dotIndex < 0 ? filename.length : dotIndex)}${
    resizeValue || ""
  }.webp`;
};
